/** @import models */

import { useQuery }             from "@apollo/client";

import { LEGAL_DATA, WORKING_HOURS } from "../../Queries/Contacts";

/** @import components */

import ContactsInformation      from "./Information";

import Requisites               from "./Requisites";

import Social                   from "./Social";

import Location                 from "./Map";

import ContactsForm             from "./Form";

import ComponentLoader          from "../Layout/Loaders/Loader";

/**
 * Get country code from domain TLD
 */
const getCountryCodeFromDomain = () => {
    const hostname = window.location.hostname;
    const tld = hostname.split(".").pop().toLowerCase();

    // Map TLD to country code
    const tldToCountryCode = {
        'lv': 'LV',
        'lt': 'LT',
        'ee': 'EE',
        'fi': 'FI',
        'se': 'SE',
        'no': 'NO'
    };

    return tldToCountryCode[tld] || null;
};

const ContactsLayout = () => { const

    countryCode = getCountryCodeFromDomain(),

    { loading: legalDataLoading, data: legalDataResult } = useQuery(LEGAL_DATA, {
        variables: { countryCode }
    }),

    { loading: workingHoursLoading, data: workingHoursResult } = useQuery(WORKING_HOURS);

    /** @return component */

    return ( <div className="contacts-information">

        <div className="left">

            { legalDataLoading || workingHoursLoading ? <ComponentLoader /> : <ContactsInformation data={ { contacts: legalDataResult?.legalData, hours: workingHoursResult?.workingHours } } /> }

            { legalDataLoading ? <ComponentLoader /> : <Requisites legalData={ legalDataResult?.legalData } /> }

            <Social />

        </div>

        <div className="right">

            <Location />

            <ContactsForm />

        </div>

    </div> );

}

/** @export ContactsLayout */
 
export default ContactsLayout;